module.exports = __webpack_public_path__ + "img/routes.dfc8ff24.png";